import { createSlice } from '@reduxjs/toolkit';

import { MonitoringSystemUser } from 'entities/MonitoringSystemUser';
import { AppError } from 'entities/Errors';

import * as action from './monitoring_system_user.action';

interface State {
  action: 'idle' | 'create' | 'update' | 'list' | 'delete' | 'refresh';
  state: 'idle' | 'loading' | 'failed' | 'succeeded';
  error: AppError | null;
  list: MonitoringSystemUser[];
  monitoringSystemUser: MonitoringSystemUser | null;
}

const initialState = {
  action: 'idle',
  state: 'idle',
  error: null,
  list: [],
  monitoringSystemUser: null,
} as State;

export const MonitoringSystemUserSlice = createSlice({
  name: 'monitoringSystemUser',
  initialState,
  reducers: {
    refresh: (state) => {
      state.action = 'idle';
      state.state = 'idle';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(action.createMonitoringSystemUser.pending, (state) => {
        state.state = 'loading';
        state.action = 'create';
        state.monitoringSystemUser = null;
        state.error = null;
      })
      .addCase(action.createMonitoringSystemUser.fulfilled, (state, action) => {
        state.state = 'succeeded';
        state.monitoringSystemUser = action.payload.data;
        state.list = [...state.list, action.payload.data];
      })
      .addCase(action.createMonitoringSystemUser.rejected, (state, action) => {
        state.state = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(action.updateMonitoringSystemUser.pending, (state) => {
        state.state = 'loading';
        state.action = 'update';
        state.error = null;
      })
      .addCase(action.updateMonitoringSystemUser.fulfilled, (state, action) => {
        state.state = 'succeeded';
        state.monitoringSystemUser = action.payload.data;
        state.list = state.list.map((x) =>
          x.id === action.payload.data.id ? action.payload.data : x
        );
      })
      .addCase(action.updateMonitoringSystemUser.rejected, (state, action) => {
        state.state = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(action.getMonitoringSystemUserList.pending, (state) => {
        state.state = 'loading';
        state.action = 'list';
        state.list = [];
        state.error = null;
      })
      .addCase(
        action.getMonitoringSystemUserList.fulfilled,
        (state, action) => {
          state.state = 'succeeded';
          state.list = action.payload.data;
        }
      )
      .addCase(action.getMonitoringSystemUserList.rejected, (state, action) => {
        state.state = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(action.deleteMonitoringSystemUser.pending, (state) => {
        state.state = 'loading';
        state.action = 'delete';
        state.error = null;
      })
      .addCase(action.deleteMonitoringSystemUser.fulfilled, (state, action) => {
        state.state = 'succeeded';
        const newList = state.list.filter(
          (x) => x.id !== action.payload.data.id
        );
        state.list = newList;
      })
      .addCase(action.deleteMonitoringSystemUser.rejected, (state, action) => {
        state.state = 'failed';
        state.error = action.payload as AppError;
      });
  },
});

export const { refresh: monitoringSystemUserRefresh } =
  MonitoringSystemUserSlice.actions;

export default MonitoringSystemUserSlice.reducer;
